import { ListingFilterKeys } from 'src/enums/listing/filter-keys';

export class ListingsFiltersForm {
  public isCashFlow: boolean;
  public statesIDs: Array<string>;
  public countiesIDs: Array<string>;
  public isShowSalePending: boolean;
  public listings: ListingFilterKeys;

  constructor(data: Partial<ListingsFiltersForm> = {}) {
    this.isCashFlow = data.isCashFlow ?? false;
    this.statesIDs = data.statesIDs ?? [];
    this.countiesIDs = data.countiesIDs ?? [];
    this.isShowSalePending = data.isShowSalePending ?? false;
    this.listings = data.listings ?? ListingFilterKeys.ACTIVE;
  }
}
